import PropTypes from 'prop-types';
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import Background from './Background';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
    this.trigger = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.request !== null && nextProps.request !== this.props.request) {
      switch (nextProps.request) {
        case 'open':
          this.setState({
            opened: true,
          }, () => {
            this.props.onChange(this.state.opened);
          });
          break;
        case 'close':
          this.setState({
            opened: false,
          }, () => {
            this.props.onChange(this.state.opened);
          });
          break;
        default:
          break;
      }
    }
  }

  handleTouchTap(evt) {
    evt.preventDefault();
    this.setState({
      opened: !this.state.opened,
    }, () => {
      this.props.onChange(this.state.opened);
    });
  }

  hideDropdown(evt) {
    evt.preventDefault();
    this.setState({
      opened: false,
    }, () => {
      this.props.onChange(this.state.opened);
    });
  }

  handleClickOutside(evt) {
    if (this.state.opened === true) {
      this.hideDropdown(evt);
    }
  }

  render() {
    const {
      className,
      size,
      position,
      label,
      wrapper,
      children,
      hideTrigger,
      trigger,
      type,
    } = this.props;
    const wrapperCls = [`uk-${type}-dropdown`];
    const triggerCls = [];
    const bodyCls = [];
    const Wrapper = wrapper;
    let triggerOffset = 0;
    let dropdownTrigger = null;
    let triggerLabel = (
      <div>{label}</div>
    );
    if (typeof label !== 'string') {
      triggerLabel = label;
    }

    if (this.trigger && hideTrigger === false) {
      triggerOffset = this.trigger.offsetHeight;
    }

    triggerCls.push(className);

    bodyCls.push('uk-dropdown');

    if (size) {
      bodyCls.push(`uk-dropdown-${size}`);
    }

    if (this.state.opened === true) {
      bodyCls.push('uk-dropdown-active');
      bodyCls.push('uk-dropdown-shown');
      wrapperCls.push('uk-open');
    }

    const bodyStyle = {};
    const [posSplitLeft, posSplitRight] = position.split('-');

    if (['left', 'center', 'top'].indexOf(posSplitRight) !== -1) {
      bodyCls.push('uk-dropdown-autoflip');
    }
    bodyCls.push(`uk-dropdown-${posSplitLeft}`);

    switch (position) {
      case 'top-left':
        bodyStyle.top = 'auto';
        bodyStyle.right = 'auto';
        bodyStyle.left = '0';
        bodyStyle.bottom = `${triggerOffset}px`;
        break;
      case 'top-center':
        bodyStyle.top = 'auto';
        bodyStyle.right = 'auto';
        bodyStyle.left = '50%';
        bodyStyle.bottom = `${triggerOffset}px`;
        bodyStyle.transform = 'translateX(-50%)';
        break;
      case 'top-right':
        bodyStyle.top = 'auto';
        bodyStyle.left = 'auto';
        bodyStyle.right = '0';
        bodyStyle.bottom = `${triggerOffset}px`;
        break;
      case 'bottom-left':
        bodyStyle.top = `${triggerOffset}px`;
        bodyStyle.right = 'auto';
        bodyStyle.left = '0';
        bodyStyle.bottom = 'auto';
        break;
      case 'bottom-center':
        bodyStyle.top = `${triggerOffset}px`;
        bodyStyle.right = 'auto';
        bodyStyle.left = '50%';
        bodyStyle.bottom = 'auto';
        bodyStyle.transform = 'translateX(-50%)';
        break;
      case 'bottom-right':
        bodyStyle.top = `${triggerOffset}px`;
        bodyStyle.left = 'auto';
        bodyStyle.right = '0';
        bodyStyle.bottom = 'auto';
        break;

      case 'right-top':
      case 'right-center':
      case 'right-bottom':
        break;

      case 'left-top':
      case 'left-center':
      case 'left-bottom':
        break;

      default:
        bodyCls.push('uk-dropdown-bottom');
        break;
    }

    if (trigger === null) {
      dropdownTrigger = (
        <a
          ref={(clicker) => { this.trigger = clicker; }}
          className={triggerCls.join(' ')}
          onClick={evt => this.handleTouchTap(evt)}
        >
          {triggerLabel}
        </a>
      );
    } else {
      dropdownTrigger = (
        <div
          ref={(clicker) => { this.trigger = clicker; }}
        >
          {trigger}
        </div>
      );
    }

    return (
      <Wrapper className={wrapperCls.join(' ')} aria-haspopup="true">
        {dropdownTrigger}
        <div className={bodyCls.join(' ')} style={bodyStyle}>
          {children}
        </div>
        <Background
          className="dropdown-background"
          onClick={(evt) => {
            this.hideDropdown(evt);
            return false;
          }}
        />
      </Wrapper>
    );
  }
}

Dropdown.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf([
    'button',
    'input',
    null,
  ]),
  size: PropTypes.oneOf([
    'small',
    'large',
    'xlarge',
    'mobile',
    null,
  ]),
  position: PropTypes.oneOf([
    'top-left',
    'top-center',
    'top-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
    'right-top',
    'right-center',
    'right-bottom',
    'left-top',
    'left-center',
    'left-bottom',
    null,
  ]),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
  wrapper: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
  // eslint-disable-next-line
  request: PropTypes.oneOf(['open', 'close', null]),
  hideTrigger: PropTypes.bool,
  trigger: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
};

Dropdown.defaultProps = {
  type: 'button',
  className: '',
  size: 'small',
  position: 'bottom-left',
  wrapper: 'div',
  request: null,
  hideTrigger: false,
  trigger: null,
  onChange: () => {},
};

export default onClickOutside(Dropdown);



// WEBPACK FOOTER //
// ./src/components/Dropdown.js